module.exports = __webpack_public_path__ + "img/logistics.710482ee.jpg";